import {Plus} from 'lucide-react'
import {useNavigate} from 'react-router-dom'
import {Button} from '@/components/ui/button'
import {Icon} from '@/components/shared/Icon'
import {InlineRow} from '@/components/shared/InlineRow'
import {useI18n} from '@/i18n'
import {routes} from '@/lib/routes'

export function NewRequestButtons() {
    const navigate = useNavigate()
    const i18n = useI18n()

    return (
        <InlineRow gap="md">
            <Button onClick={() => navigate(routes.my.functionGroupRequests.create())} data-testid="btn-new-fg-request">
                <Icon icon={Plus} className="mr-2"/>
                {i18n.myDashboard.newFunctionGroupRequest}
            </Button>
            <Button onClick={() => navigate(routes.my.requests.create())} data-testid="btn-new-request">
                <Icon icon={Plus} className="mr-2"/>
                {i18n.myDashboard.newAccessRequest}
            </Button>
        </InlineRow>
    )
}
